{
  "logLevel": "info",
  "apiSite": "https://imp.data.cms.gov",
  "useMockAdapter": false,
  "mockDelayResponse": 0,
  "mapBoxAccessToken": "pk.eyJ1IjoiY21zd25tZyIsImEiOiJja3FoNWoybTcxNzVnMm9udW1xeWU5dm1iIn0.ptrG12L1a_DmJE-41G9EGg",
  "mapBoxStateAbbrStyle": "mapbox://styles/cmswnmg/ckr2gf6eq1gwt17p8oieaaqmp",
  "mapBoxCountyStyle": "mapbox://styles/cmswnmg/ckuoib25z7v1519mwimbykquv",
  "mapBoxCbsaStyle": "mapbox://styles/cmswnmg/ckwqw54at0whb14nuoifjbzw7"
}
